import { render } from "./rtaBindForm.vue?vue&type=template&id=35815fac&scoped=true"
import script from "./rtaBindForm.vue?vue&type=script&lang=js"
export * from "./rtaBindForm.vue?vue&type=script&lang=js"

import "./rtaBindForm.vue?vue&type=style&index=0&id=35815fac&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ssp-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35815fac"]])

export default __exports__